import {
    INSERT_ROLL_EVENT,
    INSERT_EVENT,
    DELETE_EVENT,
    DELETE_COMPOUND_EVENT,
    EDIT_RESOLUTION,
    EDIT_PATTERN,
    MOVE_ROLL_EVENT,
    PASTE_SELECTION,
    DELETE_SELECTION,
    DUPLICATE_SELECTION,
    MOVE_PIANO_ROLL_PATTERN,
    SPLIT_PIANO_ROLL_PATTERN,
    PASTE_PIANO_ROLL_PATTERN,
    DUPLICATE_PIANO_ROLL_PATTERN,
    RESIZE_PIANO_ROLL_PATTERN,
} from './constants.js';
import InsertRollEvent from './InsertRollEvent.js';
import InsertEvent from './InsertEvent.js';
import DeleteEvent from './DeleteEvent.js';
import DeleteCompoundEvent from './DeleteCompoundEvent.js';
import EditResolution from './EditResolution.js';
import EditPattern from './EditPattern.js';
import MoveRollEvent from './MoveRollEvent.js';
import PasteSelection from './PasteSelection.js';
import DeleteSelection from './DeleteSelection.js';
import DuplicateSelection from './DuplicateSelection.js';
import MovePianoRollPattern from './MovePianoRollPattern.js';
import SplitPianoRollPattern from './SplitPianoRollPattern.js';
import PastePianoRollPattern from './PastePianoRollPattern.js';
import DuplicatePianoRollPattern from './DuplicatePianoRollPattern.js';
import ResizePianoRollPattern from './ResizePianoRollPattern.js';

export function dispatch(mix, action) {
    if (action === undefined) {
        action = mix;
    }

    let payload = action.payload;
    let operation = undefined;
    switch (action.type) {
    case INSERT_ROLL_EVENT:
        operation = new InsertRollEvent(
            mix, payload.event, payload.duration);
        operation.execute();
        break;
    case INSERT_EVENT:
        operation = new InsertEvent(
            mix, payload.event, payload.duration);
        operation.execute();
        break;
    case DELETE_EVENT:
        operation = new DeleteEvent(
            mix, payload.event, payload.inPlace);
        operation.execute();
        break;
    case DELETE_COMPOUND_EVENT:
        operation = new DeleteCompoundEvent(
            mix, payload.event, payload.subEvent);
        operation.execute();
        break;
    case EDIT_RESOLUTION:
        operation = new EditResolution(
            mix, payload.event, payload.resolution);
        operation.execute();
        break;
    case EDIT_PATTERN:
        operation = new EditPattern(
            mix, payload.event, payload.pattern);
        operation.execute();
        break;
    case MOVE_ROLL_EVENT:
        operation = new MoveRollEvent(
            mix, payload.event, payload.newStep);
        operation.execute();
        break;
    case PASTE_SELECTION:
        operation = new PasteSelection(
            mix, payload.step, payload.selection, payload.eventType, payload.track);
        operation.execute();
        break;
    case DELETE_SELECTION:
        operation = new DeleteSelection(
            mix, payload.selection);
        operation.execute();
        break;
    case DUPLICATE_SELECTION:
        operation = new DuplicateSelection(
            mix, payload.selection, payload.eventType);
        operation.execute();
        break;
    case MOVE_PIANO_ROLL_PATTERN:
        operation = new MovePianoRollPattern(
            payload.track, payload.pattern, payload.startStep);
        operation.execute();
        return operation;
        break;
    case SPLIT_PIANO_ROLL_PATTERN:
        operation = new SplitPianoRollPattern(
            payload.track, payload.pattern, payload.step);
        operation.execute();
        return operation;
        break;
    case PASTE_PIANO_ROLL_PATTERN:
        operation = new PastePianoRollPattern(
            payload.track, payload.pattern, payload.step);
        operation.execute();
        return operation;
        break;
    case DUPLICATE_PIANO_ROLL_PATTERN:
        operation = new DuplicatePianoRollPattern(
            payload.track, payload.pattern);
        operation.execute();
        return operation;
        break;
    case RESIZE_PIANO_ROLL_PATTERN:
        operation = new ResizePianoRollPattern(
            payload.pattern, payload.direction, payload.resizedStep);
        operation.execute();
        return operation;
        break;
    default:
        return;
    }

    if (payload.event) {
        if (payload.event.parentEvent) {
            mix.updateTypeRedux(payload.event.parentEvent.getType());
            mix.prune(payload.event.parentEvent.getType());
        } else {
            mix.updateTypeRedux(payload.event.getType());
            mix.prune(payload.event.getType());
        }
    } else {
        mix.updateAllTypeRedux();
    }

    return operation;
}
